import { View } from "@react-pdf/renderer";
import PdfSectionTitle from "./typography/PdfSectionTitle";

const PdfArrayObjectItem = ({ children, title }) => (
  <ArrayObjectItem>
    <PdfSectionTitle>{title}</PdfSectionTitle>

    {children}
  </ArrayObjectItem>
);

const ArrayObjectItem = ({ children }) => (
  <View
    style={{
      marginBottom: 15,
      padding: 10,
      backgroundColor: "#f9f9f9",
      borderRadius: 5,
    }}
  >
    {children}
  </View>
);

export default PdfArrayObjectItem;
